import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { isOrthodoxMode } from "./utils/featureFlags";

import "./i18n";

if (isOrthodoxMode) {
  document.body.classList.add("orthodox-mode");
  document.title = "זיכרון בבית";

  const faviconLinks = document.querySelectorAll<HTMLLinkElement>("link[rel='icon'], link[rel='apple-touch-icon']");
  faviconLinks.forEach((link) => {
    link.href = "/orthodoxFavicon.png";
  });
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
